import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { AlertController, LoadingController, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ProductResource } from '../api/product.resource.service';
import { MultiScanResultModalComponent } from '../products/multi-scan-result-modal/multi-scan-result-modal.component';
import { BarcodeScannerListner } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class BarcodeScannerService {

  bcListner: BarcodeScannerListner;

  constructor(
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private translateService: TranslateService,
    private productResource: ProductResource,
    private router: Router,
    private modalCtrl: ModalController,
  ) { }

  get canScanBarcode() {
    return !!(window as any).cordova;
  }

  init(routeBack?: boolean) {
    if (!this.canScanBarcode) {
      this.bcListner = new BarcodeScannerListner(async (barcode) => {
        if (routeBack) {
          window.history.back();
        }
        this.handleBarcodeScan(barcode);
      });
    }
  }

  destroy() {
    if (this.bcListner) {
      try {
        this.bcListner.destroy();
      } catch (error) { }
    }
  }



  async scanBarcode(routeBack?: boolean, testBC?: string) {
    let scanResult;

    if (!testBC) {
      scanResult = await BarcodeScanner.scan();
    } else {
      scanResult = { text: testBC };
    }
    if (routeBack) {
      window.history.back();
    }
    if (scanResult.text) {
      await this.handleBarcodeScan(scanResult.text);;
    }
  }

  private async handleBarcodeScan(barcode: string) {
    const loader = await this.loadingCtrl.create({
      message: this.translateService.instant('sa_products_searching_products')
    });
    loader.present();
    try {

      const [pro] = (await this.productResource.query({ 'products.barcode': barcode, 'producttranslations.language1': localStorage.getItem('prefLanguage') })).results;

      let variationResults;
      if (!pro && barcode.length >= 5) {
        variationResults = (await this.productResource.query({ 'products.barcode': '*' + barcode, 'producttranslations.language1': localStorage.getItem('prefLanguage') })).results;
      }

      if (pro) {
        // single product
        this.router.navigate(['/main/products/detail/', pro.productkey])
      } else if (variationResults && variationResults.length > 0) {
        // product variations
        (await this.modalCtrl.create({
          component: MultiScanResultModalComponent,
          componentProps: {
            results: variationResults
          }
        })).present();
      } else {
        // no product found
        (await this.alertCtrl.create({
          header: this.translateService.instant('sa_product_not_found_alert_header'),
          message: this.translateService.instant('sa_product_not_found_alert_message'),
          buttons: [this.translateService.instant('sa_product_not_found_alert_btn')]
        })).present();
      }
    } catch (error) {

    }
    loader.dismiss();

  }


}
